import { memo } from "react";
import moment from "moment";

import BotaoTabela from "../../../Componentes/BotaoTabela";

function Registro({
    id,
    nome,
    nomeEvento,
    numeroSorte,
    dataNascimento,
    clicouVerDetalhes
}) {
    const dataNascimentoFormatada = moment(dataNascimento).format('DD/MM/YYYY');
    return (
        <tr>
            <td className="estreito">{id}</td>
            <td className="text-center font-weight-bold">{numeroSorte}</td>
            <td>{nome}</td>
            <td>{dataNascimentoFormatada}</td>
            <td>{nomeEvento}</td>
            <td className="text-nowrap estreito">
                <BotaoTabela
                    onClick={clicouVerDetalhes}
                    icone={["fas", "eye"]}
                >
                    Ver mais detalhes
                </BotaoTabela>
            </td>
        </tr>
    )
}

export default memo(Registro);